/* eslint-disable react/no-multi-comp */
import React, { Component, PureComponent } from 'react';
import { routerShape } from 'react-router';
import scrollToComponent from 'react-scroll-to-component-ssr';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import each from 'lodash/each';
import toNumber from 'lodash/toNumber';
import get from 'lodash/get';
import Bem from 'bemHelper';
import numDesc from 'helpers/numDesc';
import { I18nHoc } from 'helpers/i18n';
import { subscribe, unsubscribe, emit } from 'helpers/global-events';
import apiDecorator from 'api/api-decorator';
import { UserProp } from 'auth';
import sensor from 'components/sensor';
import Button from 'components/button';
import { iconTypes } from 'components/icon';
import ClipboardCopy from 'components/clipboard-copy';

import Comment from './comment';
import { CommentProp } from './shapes';

import translates from './comments-i18n.json';

const bemClassesJump = new Bem('jumpToNew');

@sensor
class JumpToNew extends Component {
  static propTypes = {
    jump: PropTypes.func,
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      newCount: 0,
      top: 0
    };
    this.newList = [];
    this.onResize = this.setPosition;
    this.jump = this.jump.bind(this);
    this.setPosition = this.setPosition.bind(this);
  }

  componentDidUpdate() {
    if (!this.state.top) this.setPosition();
  }

  setPosition() {
    const top = window.innerHeight / 3;
    if (top !== this.state.top) return this.setState({ top });
  }

  init(newList) {
    this.newList = newList;
    this.newPoint = 0;
    emit('commentsCountUpdate', newList.length);
    this.setState({ newCount: newList.length });
  }

  jump() {
    const to = this.newList[this.newPoint];
    this.newPoint += 1;
    emit('commentsCountUpdate', this.state.newCount - 1);
    this.setState({
      newCount: this.state.newCount - 1
    });
    this.props.jump(to);
  }

  render() {
    const { top } = this.state;

    return (
      <div {...bemClassesJump('')} style={{ top }}>
        {this.state.newCount !== 0 &&
          <Button
            {...bemClassesJump('btn', 'jumpToNew')}
            onClick={this.jump}
            iconType={iconTypes.dropdown}
            label={this.state.newCount}
            noPadding
          />
        }
      </div>
    );
  }
}

const bemClassesList = new Bem('listComments');

@apiDecorator
@sensor
@I18nHoc(translates)
class List extends Component {
  static propTypes = {
    entity: PropTypes.string.isRequired,
    entityId: PropTypes.number.isRequired,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]),
    auth: UserProp,
    comments: PropTypes.arrayOf(PropTypes.shape(CommentProp)),
    commentsCount: PropTypes.number,
    commentsReloadCount: PropTypes.any, //eslint-disable-line
    expandComments: PropTypes.func,
    noInteraction: PropTypes.bool,
    noVisitingCard: PropTypes.bool,
    formController: PropTypes.string,
    topic: PropTypes.string,
    subscribeList: PropTypes.bool,
    autoHideReply: PropTypes.bool,
    showCountNewComments: PropTypes.bool,
  };

  static contextTypes = {
    router: routerShape
  };

  constructor(props, context) {
    super(props, context);

    this.router = context.router;
    this.componentInReply = null;
    this.newRefs = {};
    this.jumpBtn = null;
    this.slideTimer = null;
    this.commentData = null;
    this.previousId = null;
    this.clipboardCopy = null;
    this.scrollConfig = {
      align: 'top',
      ease: 'linear',
      duration: 300
    };

    this.reply = this.reply.bind(this);
    this.jump = this.jump.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  componentDidMount() {
    const heightHeader = toNumber(this.sensor.getVariable('heightHeaderPx'));

    // Update last view for user
    this.api.get('action/comment/actions/last-view', {
      queryString: {
        entity: this.props.entity,
        entity_id: this.props.entityId
      }
    }).then((payload) => {
      this.newRefs = {};
      if (!payload || payload.length === 0) return;

      each(payload, val => this.newRefs[val] = true);
      // if (this.jumpBtn) this.jumpBtn.init(this.newList);
      this.forceUpdate();
    });

    let commentId;
    if (__CLIENT__ && !this.props.noInteraction) {
      commentId = this.router.params.comment;
      if (!commentId) {
        commentId = +(get(this, 'router.location.hash').replace(/\D+/g, ''));
      }
    }

    if (commentId > 0) {
      if (commentId) {
        if (!this[`comment${commentId}Ref`]) {
          this.commentData = { id: commentId, offset: -(heightHeader) };
          return this.props.expandComments();
        }
        this.commentData = { id: commentId, offset: -(heightHeader) };
        // TODO refactor this
        setTimeout(() => this.scrollToComment(), 4000);
      }
    }
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.entity !== nextProps.entity ||
      this.props.entityId !== nextProps.entityId ||
      this.props.commentsReloadCount !== nextProps.commentsReloadCount ||
      this.props.auth.authenticated !== nextProps.auth.authenticated
    );
  }

  componentDidUpdate(prevProps) {
    if (
      !this.props.noInteraction && prevProps.comments.length &&
      this.props.comments.length >= prevProps.comments.length &&
      this.commentData
    ) {
      this.scrollToComment();
    }
  }

  /**
   * Close comment, that now in reply state
   * @param comp
   */
  reply(comp) {
    const c = this.componentInReply;
    if (c) {
      c.closeReply();
    }
    this.componentInReply = comp;
  }

  jump(id) {
    if (this.newRefs[id]) {
      if (this.previousId) this.newRefs[this.previousId].setOld();
      this.previousId = id;
    }
    // TODO: implement jumping to comment!
    const defaultButtonHeight = -(window.innerHeight / 3) + 10;
    if (!this[`comment${id}Ref`]) {
      this.props.expandComments();
      return this.commentData = { id, offset: defaultButtonHeight };
    }
    this.commentData = { id, offset: defaultButtonHeight };
    this.scrollToComment();
  }

  scrollToComment() {
    const id = get(this, 'commentData.id');
    const offset = get(this, 'commentData.offset');
    if (!id) return null;

    scrollToComponent(this[`comment${id}Ref`], {
      ...this.scrollConfig,
      offset
    });
    this.commentData = null;
  }

  copyToClipboard(text, afterCopyAction = null) {
    if (this.clipboardCopy) {
      this.clipboardCopy.copy(text, afterCopyAction);
    }
  }

  render() {
    const { i18n } = this;
    const {
      comments, commentsCount,
      noInteraction, noVisitingCard, title, showCountNewComments,
      topic, subscribeList, autoHideReply,
      ...otherProps
    } = this.props;
    const aboutTopic = topic ? i18n('commentsAboutTopic', { placeholder: topic }) : '';
    const commentsCountAboutTopic = (
      numDesc(
        commentsCount, i18n('commentCount'), i18n('commentCountDeclination'), i18n('commentCountMultiple')
      ) + aboutTopic
    );
    const HtmlElement = title ? 'div' : 'span';

    return (
      <div {...bemClassesList()}>
        <div {...bemClassesList('countContainer')}>
          <div {...bemClassesList('countContainerMain')}>
            <HtmlElement {...bemClassesList('textContainer', 'gray')}>
              {title && <HtmlElement {...bemClassesList('text')} children={title} />}
            </HtmlElement>
            <span {...bemClassesList('textContainer', 'main')}>
              <span {...bemClassesList('text')} children={commentsCountAboutTopic} />
            </span>
          </div>
          {!noInteraction && showCountNewComments &&
            <NewCommentsCount {...bemClassesList('countContainerNew')} />
          }
        </div>
        {!noInteraction &&
          <>
            <JumpToNew jump={this.jump} ref={el => this.jumpBtn = el} />
            <ClipboardCopy
              ref={el => this.clipboardCopy = el}
              successMessage={i18n('commentLinkCopyMassage')}
            />
          </>
        }
        {map(comments, (comment, key) => (
          <Comment
            key={key}
            commentRef={ref => this[`comment${comment.id}Ref`] = ref}
            comment={comment}
            reply={this.reply}
            isNew={!!this.newRefs[comment.id]}
            noInteraction={noInteraction}
            noVisitingCard={noVisitingCard}
            copyToClipboard={this.copyToClipboard}
            subscribe={subscribeList}
            topic={topic}
            autoHideReply={autoHideReply}
            {...otherProps}
          />
        ))}
      </div>
    );
  }
}

const bemClassesNew = new Bem('commentsCountNew');

@sensor
@I18nHoc(translates)
class NewCommentsCount extends PureComponent {
  static propTypes = {
    className: PropTypes.string
  };

  constructor(...props) {
    super(...props);
    this.countUpdate = this.countUpdate.bind(this);
    this.updateComponent = this.updateComponent.bind(this);
    this.onResize = this.updateComponent.bind(this);

    this.state = { phone: false, count: 0 };

    subscribe('commentsCountUpdate', count => this.countUpdate(count));
  }

  componentDidMount() {
    this.updateComponent(this.sensor.getRuntime());
  }

  componentWillUnmount() {
    unsubscribe('commentsCountUpdate', this.countUpdate);
  }

  updateComponent({ media: { phone } = {} }) {
    if (phone !== this.state.phone) this.setState({ phone });
  }

  countUpdate(count) {
    this.setState({ count });
  }

  render() {
    if (this.state.phone) return null;

    const { i18n } = this;

    return (
      <div {...bemClassesNew({ extra: this.props.className })}>
        <span {...bemClassesNew('textContainer')}>
          <span {...bemClassesNew('text')} children={i18n('commentsCountNew')} />
        </span>
        <span {...bemClassesNew('textContainer', 'count')}>
          <span {...bemClassesNew('text')} children={this.state.count} />
        </span>
      </div>
    );
  }
}

export default List;
